import { removeDuplicate } from 'utils/array'

export const sortAllArrayInObject = (obj: object) => {
  return Object?.keys(obj ?? {})?.reduce((acc, key) => {
    let childVal = obj[key]
    if (Array.isArray(childVal)) {
      childVal = removeDuplicate?.(childVal)?.sort()
    }
    if (childVal?.constructor?.name === 'Object') {
      childVal = sortAllArrayInObject(childVal)
    }
    acc[key] = childVal
    return acc
  }, {})
}
